import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '下载教程', path: '/category/xiazai-jiaocheng' },
  { name: '功能介绍', path: '/category/gongneng-jieshao' },
  { name: '使用技巧', path: '/category/shiyong-jiqiao' },
  { name: '常见问题', path: '/category/changjian-wenti' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-950 whitespace-nowrap">
              快猫app
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  isActive(link.path)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#download"
              className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即下载
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-800 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="#download"
              className="block px-4 py-2.5 mt-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold text-center hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即下载
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}